export default __webpack_public_path__ + "f0058f27c3792865d2460b0a97bcba29.jpg";